// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "terminal" + "-legacy." + "f51b6bb9" + ".js";
};